import { Form } from "antd";
import { HeaderOverview } from "components";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashboardWeb } from "service/dashboard/property/overview";
import { SpaceStyle } from "..";
import { LoadingDashboard, Wrapper } from "../..";

const BackOffice = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const backOfficePropertyDate = Form.useWatch("backOfficePropertyDate");
  const date = findDate(backOfficePropertyDate, "month");

  const data = useGetPropertyDashboardWeb({
    ...date,
  });

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={false}>
        <HeaderOverview
          title={t("number-of-user-using-back-office")}
          name="backOfficePropertyDate"
        />
        <SpaceStyle className="center" direction="vertical">
          <div className="count" style={{fontSize:"36px"}}>{`${data.data || "0"}`}</div>
          <div className="people" style={{fontSize:"24px"}}>{t("people")}</div>
        </SpaceStyle>
      </LoadingDashboard>
    </Wrapper>
  );
};

export default BackOffice;
